export function isBrowser() {
  return typeof window !== 'undefined';
}

export function isMobile() {
  return window.innerWidth < 768;
}
